/**
 * Timestamp helpers for the wire formats greenhouse-api uses.
 *
 * The API reports time-series timestamps as **epoch seconds** — `t` on
 * `/metrics/:id/history` buckets, `timestamp` on `/readings` rows — while the
 * record-style endpoints (tasks, issues, audit) use ISO 8601 strings. Feeding a
 * seconds value straight into `new Date()` reads it as milliseconds and lands in
 * 1970, so every series timestamp is normalized at the API boundary instead.
 */

/**
 * Normalize a wire timestamp to epoch milliseconds.
 *
 * Accepts epoch seconds (number or all-digit string) and ISO 8601 strings, so a
 * chart can be fed from either endpoint family without caring which it came from.
 *
 * @param {number|string|null|undefined} value
 * @return {number|null} Epoch milliseconds, or null when unparseable.
 */
export function toEpochMs(value) {
    if (value === null || value === undefined || value === '')
        return null
    if (typeof value === 'number')
        return Number.isFinite(value) ? value * 1000 : null
    const str = String(value)
    if (/^-?\d+$/.test(str))
        return parseInt(str, 10) * 1000
    const parsed = Date.parse(str)
    return Number.isNaN(parsed) ? null : parsed
}

/**
 * Convert epoch milliseconds to the epoch seconds the API expects in `from`/`to`
 * query parameters.
 * @param {number} ms
 * @return {number}
 */
export function toEpochSeconds(ms) {
    return Math.floor(ms / 1000)
}
